// Client-side tracker: posts events to /api/events for MBE Alert Analytics dashboard
// Also complements Meta Pixel (both fire in parallel).

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const EVENTS_ENDPOINT = `${BACKEND_URL}/api/events`;
const SESSION_KEY = 'mbe_session_v1';

const uuid = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return 'sess-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
};

const getSessionId = () => {
  try {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = uuid();
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch (e) {
    return uuid();
  }
};

const getUtmParams = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get('utm_source') || null,
      utm_medium: p.get('utm_medium') || null,
      utm_campaign: p.get('utm_campaign') || null,
      utm_content: p.get('utm_content') || null,
      utm_term: p.get('utm_term') || null,
    };
  } catch (e) {
    return {};
  }
};

const post = (payload) => {
  try {
    const body = JSON.stringify(payload);
    // Prefer sendBeacon for click events (fire-and-forget, survives navigation)
    if (payload.event_type === 'cta_click' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(EVENTS_ENDPOINT, blob);
      return;
    }
    fetch(EVENTS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* noop */
  }
};

export const trackPageView = ({ country, source } = {}) => {
  const utm = getUtmParams();
  post({
    event_type: 'page_view',
    session_id: getSessionId(),
    country: country || (window.__mbeCountry || null),
    country_source: source || (window.__mbeCountrySource || null),
    referrer: document.referrer || null,
    path: window.location.pathname,
    ...utm,
  });
};

export const trackCtaClick = ({ url, label } = {}) => {
  const utm = getUtmParams();
  post({
    event_type: 'cta_click',
    session_id: getSessionId(),
    country: window.__mbeCountry || null,
    country_source: window.__mbeCountrySource || null,
    cta_url: url || null,
    referrer: document.referrer || null,
    path: window.location.pathname,
    label: label || null,
    ...utm,
  });
};

// Attach a global click listener to auto-capture Telegram CTA clicks.
// This is called once on mount (from App).
export const installClickTracker = () => {
  if (window.__mbeClickTrackerInstalled) return;
  window.__mbeClickTrackerInstalled = true;

  document.addEventListener(
    'click',
    (e) => {
      const el = e.target && e.target.closest ? e.target.closest('a, button') : null;
      if (!el) return;
      if (el.id === 'emergent-badge') return;
      const href = el.getAttribute && el.getAttribute('href');
      if (!href || href.indexOf('t.me/') === -1) return;
      const label = (el.textContent || '').trim().slice(0, 80);
      trackCtaClick({ url: href, label });
    },
    true
  );
};

export const getStoredSessionId = getSessionId;
